// src/lib/twilioClient.ts
import { Conversation, Client as ConversationsClient } from '@twilio/conversations';

let convClient: ConversationsClient | null = null;

export async function getOrInitTwilioClient(getToken: () => Promise<string>) {
  if (convClient) return convClient;

  const token = await getToken();
  convClient = new ConversationsClient(token);

  // Auto refresh token
  convClient.on('tokenAboutToExpire', async () => {
    try { await convClient?.updateToken(await getToken()); } catch { }
  });
  convClient.on('tokenExpired', async () => {
    try { await convClient?.updateToken(await getToken()); } catch { }
  });

  // Wait until connected (or error)
  await new Promise<void>((resolve, reject) => {
    const onState = (state: ConversationsClient['connectionState']) => {
      if (state === 'connected') {
        convClient?.off('connectionStateChanged', onState);
        resolve();
      } else if (state === 'denied') {
        console.log("Connection denied");
        convClient?.off('connectionStateChanged', onState);
        reject(new Error('Twilio Conversations connection denied'));
      }
    };
    convClient!.on('connectionStateChanged', onState);
  });

  return convClient;
}

/**
 * Get the singleton Twilio client (if already initialized)
 */
export function getConvClient(): ConversationsClient | null {
  return convClient;
}

/**
 * Get a conversation by its SID using the singleton client
 */
export async function getConversationBySid(conversationSid: string): Promise<Conversation | null> {
  if (!convClient) {
    console.warn('Twilio client not initialized');
    return null;
  }
  try {
    return await convClient.getConversationBySid(conversationSid);
  } catch (error) {
    console.error('Failed to get conversation by SID:', error);
    return null;
  }
}